(function () {
  function normalizeNumber(rawNumber, countryCode) {
    var number = String(rawNumber || '').replace(/\D/g, '');
    var country = String(countryCode || '55').replace(/\D/g, '') || '55';

    if (!number) return '';
    if (number.indexOf(country) === 0) return number;

    return country + number;
  }

  function buildWhatsappUrl(number, message) {
    var url = 'https://wa.me/' + number;

    if (message) {
      url += '?text=' + encodeURIComponent(message);
    }

    return url;
  }

  function openUrl(url, openNewTab) {
    if (openNewTab) {
      var opened = window.open(url, '_blank', 'noopener,noreferrer');

      if (opened) {
        opened.opener = null;
      }

      return;
    }

    window.location.href = url;
  }

  function fallbackCopyText(text) {
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');

      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        if (document.execCommand('copy')) {
          resolve();
        } else {
          reject(new Error('Copy command failed'));
        }
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () {
        return fallbackCopyText(text);
      });
    }

    return fallbackCopyText(text);
  }

  function getStoredRotationIndex(storageKey) {
    try {
      var storedIndex = window.localStorage.getItem(storageKey);

      if (storedIndex !== null) {
        var parsedIndex = parseInt(storedIndex, 10);

        if (!Number.isNaN(parsedIndex)) {
          return parsedIndex;
        }
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function setStoredRotationIndex(storageKey, index) {
    try {
      window.localStorage.setItem(storageKey, String(index));
    } catch (error) {
      // Some browsers block storage in private contexts; the in-page dataset still keeps the sequence.
    }
  }

  function getSequentialWhatsappNumber(numbers, link) {
    var rotationKey = link.dataset.whatsappRotationKey || link.dataset.whatsappNumbers || 'default';
    var storageKey = 'floating-contact-whatsapp-rotation:' + rotationKey;
    var storedIndex = getStoredRotationIndex(storageKey);
    var currentIndex = storedIndex;

    if (currentIndex === null) {
      currentIndex = parseInt(link.dataset.whatsappRotationIndex || '0', 10);
    }

    if (Number.isNaN(currentIndex)) {
      currentIndex = 0;
    }

    var selectedIndex = ((currentIndex % numbers.length) + numbers.length) % numbers.length;
    var nextIndex = (selectedIndex + 1) % numbers.length;

    link.dataset.whatsappRotationIndex = String(nextIndex);
    setStoredRotationIndex(storageKey, nextIndex);

    return numbers[selectedIndex];
  }

  function initFloatingContact(root) {
    var button = root.querySelector('[data-floating-contact-button]');
    var panel = root.querySelector('[data-floating-contact-panel]');

    if (!button || !panel) return;

    function openPanel() {
      panel.hidden = false;
      button.setAttribute('aria-expanded', 'true');

      window.requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
    }

    function closePanel() {
      panel.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');

      window.setTimeout(function () {
        if (button.getAttribute('aria-expanded') === 'false') {
          panel.hidden = true;
        }
      }, 180);
    }

    function togglePanel() {
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    }

    button.addEventListener('click', function () {
      togglePanel();
    });

    root.addEventListener('click', function (event) {
      var emailLink = event.target.closest('[data-floating-contact-copy-email]');
      var randomLink = event.target.closest('[data-floating-contact-random]');

      if (emailLink) {
        var email = emailLink.dataset.emailAddress;
        var label = emailLink.querySelector('.floating-contact__item-label');
        var originalLabel = label ? label.dataset.originalLabel || label.textContent : '';

        if (!email) return;

        event.preventDefault();

        copyText(email).then(function () {
          if (!label) return;

          label.dataset.originalLabel = originalLabel;
          label.textContent = 'Copiado';
          window.clearTimeout(emailLink.copyFeedbackTimeout);

          emailLink.copyFeedbackTimeout = window.setTimeout(function () {
            label.textContent = originalLabel;
          }, 1600);
        }).catch(function () {
          if (label) {
            label.textContent = originalLabel;
          }
        });

        return;
      }

      if (!randomLink) return;

      var numbers = String(randomLink.dataset.whatsappNumbers || '')
        .split(/[\n,;|]+/)
        .map(function (number) {
          return normalizeNumber(number, randomLink.dataset.countryCode);
        })
        .filter(Boolean);

      if (!numbers.length) return;

      event.preventDefault();

      var selectedNumber = getSequentialWhatsappNumber(numbers, randomLink);
      var url = buildWhatsappUrl(selectedNumber, randomLink.dataset.whatsappMessage || '');
      var openNewTab = randomLink.dataset.openNewTab !== 'false';

      openUrl(url, openNewTab);
      closePanel();
    });

    document.addEventListener('click', function (event) {
      if (panel.hidden || root.contains(event.target)) return;
      closePanel();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        closePanel();
        button.focus();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-floating-contact]').forEach(initFloatingContact);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
